function initialState() {
  return {
    MapInstance: null,
    Geocoder: null,
    AutocompleteService: null,
    PlacesService: null,
    CurrentMarker: null,
    ShowGoogleMapsModal: false,
    GoogleMapsInfo: null,
    GOOGLE_MAPS_API_KEY: "AIzaSyAKBEhdr_zLmRm9h5XBfQneExZRkW2g3xE"
  };
}
const state = initialState();

const actions = {
  openAddressOnGoogleMaps: async function(context, address) {
    context.commit("updateGoogleMapsInfo", address);
    context.commit("toggleGoogleMapsModal", true);
  },
  closeGoogleMapsModal(context) {
    context.commit("toggleGoogleMapsModal", false);
  }
};

const mutations = {
  toggleGoogleMapsModal(state, value) {
    state.ShowGoogleMapsModal = value;
  },
  updateGoogleMapsInfo(state, address) {
    state.GoogleMapsInfo = address;
  },
  updateCurrentMarker(state, marker) {
    state.CurrentMarker = marker;
  }
};

export default {
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/GoogleMaps.js